export default __webpack_public_path__ + "static/media/qana-project-3.34b04b3c.webp";